import React from 'react'
import enhance from './enhancers'
import { Button, Input } from 'modules/ui'
import { cercaLogo } from 'modules/ui/assets'

export function SignIn({
  email,
  path,
  submitForm,
  theme,
  updateEmail,
  invalid
}) {
  return (
    <form onSubmit={submitForm} className={theme.signInForm}>
      <img className={theme.cercaIcon} src={cercaLogo} alt="ThinkCERCA" />
      <Input
        type="text"
        label="Name"
        name="email"
        value={email}
        onChange={updateEmail}
      />
      <div className={theme.submit}>
        <Button
          type="submit"
          disabled={invalid}
          onClick={submitForm}
          to={path}
          primary
          raised
          icon="arrow_forward"
          label="Begin"
        />
      </div>
    </form>
  )
}

export default enhance(SignIn)



// WEBPACK FOOTER //
// ./client/modules/user/components/SignIn/index.js